import {
  createRedoReferralsRpcClient,
  type RedoReferralsRpcClient,
} from "@redotech/redo-referrals-api/client";
import {
  type Context,
  createContext,
  type ReactNode,
  useContext,
  useMemo,
} from "react";

import { REDO_REFERRALS_SERVER_URL } from "../config";

export const RedoReferralsRpcClientContext: Context<
  RedoReferralsRpcClient | undefined
> = createContext<RedoReferralsRpcClient | undefined>(undefined);
RedoReferralsRpcClientContext.displayName = "RedoReferralsRpcClientContext";

export function RedoReferralsRpcClientProvider({
  children,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  authToken: string | undefined;
}) {
  // `ClientOptions.headers` is captured at construction time, so the
  // client must be reconstructed whenever the token changes. useMemo
  // keyed on the token gives us the same identity across renders that
  // share an auth state.
  const client = useMemo(() => {
    return createRedoReferralsRpcClient({
      baseURL: new URL(`${REDO_REFERRALS_SERVER_URL}/rpc`),
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    });
  }, [authToken]);
  return (
    <RedoReferralsRpcClientContext.Provider value={client}>
      {children}
    </RedoReferralsRpcClientContext.Provider>
  );
}

export function useRedoReferralsRpcClient(): RedoReferralsRpcClient {
  const client = useContext(RedoReferralsRpcClientContext);
  if (!client) {
    throw new Error(
      "useRedoPartnersRpcClient must be used within RedoPartnersRpcClientProvider",
    );
  }
  return client;
}
